import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';

function Login({ theme, showNotification, setToken, setIsDemo }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
    withCredentials: true, // si tu as des cookies/auth
  });

  // Interceptor : ajoute le token à chaque requête
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token'); // ou ton state/context
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/login', { email, password });
      localStorage.setItem('token', response.data.access_token); // ou ton setToken
      setToken(response.data.access_token);
      showNotification('Connexion réussie !', 'success');
      setIsDemo(false);
      navigate('/dashboard');
    } catch (error) {
      showNotification('Erreur lors de la connexion : ' + (error.response?.data?.detail || 'Vérifiez vos identifiants'), 'error');
    }
  };

  return (
    <div className={`min-h-screen ${theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'} flex items-center justify-center p-6`}>
      <div className={`w-full max-w-md p-8 rounded-2xl shadow-2xl ${theme === 'light' ? 'bg-white' : 'bg-gray-800'} border ${theme === 'light' ? 'border-gray-200' : 'border-gray-700'}`}>
        <h2 className={`text-3xl font-bold text-center mb-8 ${theme === 'light' ? 'text-gray-900' : 'text-gray-100'}`}>
          Se connecter
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className={`block text-sm font-medium mb-2 ${theme === 'light' ? 'text-gray-700' : 'text-gray-300'}`}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`w-full px-4 py-3 rounded-lg border ${theme === 'light' ? 'border-gray-300 bg-white focus:border-blue-500' : 'border-gray-600 bg-gray-700 focus:border-blue-400'} focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 transition`}
              required
              placeholder="vous@exemple.com"
            />
          </div>

          <div>
            <label className={`block text-sm font-medium mb-2 ${theme === 'light' ? 'text-gray-700' : 'text-gray-300'}`}>
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`w-full px-4 py-3 rounded-lg border ${theme === 'light' ? 'border-gray-300 bg-white focus:border-blue-500' : 'border-gray-600 bg-gray-700 focus:border-blue-400'} focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 transition`}
              required
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3.5 px-6 text-lg font-semibold text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg hover:from-green-600 hover:to-emerald-700 transform hover:scale-105 transition duration-200 shadow-lg"
          >
            Connexion
          </button>
        </form>

        <p className={`text-center mt-6 text-sm ${theme === 'light' ? 'text-gray-600' : 'text-gray-400'}`}>
          Pas de compte ?{' '}
          <a href="/signup" className="font-medium text-blue-600 dark:text-blue-400 hover:underline">
            Créer un compte
          </a>
        </p>

        {/* Séparateur "Ou" */}
        <div className="relative my-8">
          <div className="absolute inset-0 flex items-center">
            <div className={`w-full border-t ${theme === 'light' ? 'border-gray-300' : 'border-gray-600'}`} />
          </div>
          <div className="relative flex justify-center">
            <span className={`px-4 text-sm font-medium ${theme === 'light' ? 'bg-white text-gray-500' : 'bg-gray-800 text-gray-400'}`}>
              Ou
            </span>
          </div>
        </div>

        {/* Bouton Google - parfaitement intégré */}
        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={async (credentialResponse) => {
              try {
                const res = await api.post('/api/auth/google', {
                  credential: credentialResponse.credential
                });
                localStorage.setItem('token', res.data.access_token);
                setToken(res.data.access_token);
                showNotification('Connexion avec Google réussie !', 'success');
                setIsDemo(false);
                navigate('/dashboard');
              } catch (err) {
                showNotification('Erreur avec Google : ' + (err.response?.data?.detail || err.message), 'error');
              }
            }}
            onError={() => {
              showNotification('Échec de la connexion Google', 'error');
            }}
            useOneTap={false}
            theme={theme === 'dark' ? 'filled_black' : 'outline'}
            size="large"
            text="continue_with"
            shape="rectangular"
            width="100%"
            logo_alignment="center"
          />
        </div>

      </div>
    </div>
  );
}

export default Login;